import { ToastContainer } from 'react-toastify';
import styles from '../css/header.module.scss';
import { useAuth } from '../context/AuthContext';
import LanguageHandler from '../components/languageHandler';
import '../css/languageHandlerHeader.scss';

const Header = () => {
  const { user } = useAuth();

  const handleToggleMobileMenu = () => {
    const sidebar = document.getElementById('sidebar');
    if (sidebar) {
      sidebar.classList.toggle('active');
    }
  };
  return (
    <header className={styles.header}>
      <div>
        <ToastContainer />
        <a href="/">
          <img className={styles.logo} src="/assets/images/travel-care-logo.svg" alt="Logo" />
        </a>
      </div>
      <div className="header-right">
        <div className="language-wrapper">
          <LanguageHandler />
        </div>
        <div className={styles.desktopUserAvatar} onClick={handleToggleMobileMenu}>
          <p>{(user?.firstName ?? '')?.charAt(0)?.toUpperCase() + (user?.lastName ?? '')?.charAt(0)?.toUpperCase()}</p>
        </div>
      </div>
      <div className={styles.hamburgerMenu} onClick={handleToggleMobileMenu}>
        <img src="/assets/images/hamburger.svg" alt="Menu" />
      </div>
    </header>
  );
};

export default Header;
